import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { GeocodeResult } from '@yandex-maps/const';
import { GeocodeService } from '@yandex-maps/feature';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { DeliveryAddressDialogComponentService } from '../delivery-address-dialog.component.service';

@Component({
  selector: 'sd-delivery-address-map',
  templateUrl: './delivery-address-map.component.html',
  styleUrls: ['./delivery-address-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeliveryAddressMapComponent implements OnDestroy {
  balloon: ymaps.Balloon;

  private mapInstance: ymaps.Map;
  private subscription = new Subscription();

  constructor(
    private geocodeService: GeocodeService,
    public componentService: DeliveryAddressDialogComponentService,
  ) {}

  onMapCreated(mapInstance: ymaps.Map): void {
    this.mapInstance = mapInstance;
    this.createBalloon(mapInstance);

    mapInstance.events.add('click', this.onMapClick);

    this.subscription.add(
      this.componentService.suggestedCoords$.pipe(filter<ymaps.Coordinate>(Boolean)).subscribe((coordinates) => {
        this.geocodeService
          .getAddressByCoords(coordinates)
          .pipe(take(1))
          .subscribe((address) => {
            this.mapInstance.geoObjects.removeAll();
            this.balloon.close();
            this.mapInstance.setZoom(14);
            this.mapInstance.setCenter(coordinates);

            this.mapInstance.geoObjects.add(
              new ymaps.Placemark(
                coordinates,
                { iconCaption: address.split(',').slice(2).join(',') },
                { id: 'userPlacemark', preset: 'islands#orangeCircleDotIcon' },
              ),
            );
          });
      }),
    );
  }

  onMapClick = (e: ymaps.Event): void => {
    const coords = e.get<ymaps.Coordinate>('coords');

    this.subscription.add(
      this.geocodeService.getGeoObject(coords).subscribe((geocodeResult: GeocodeResult) => {
        this.mapInstance?.geoObjects.removeAll();
        this.openBalloon(coords, geocodeResult.getAddressLine());
        this.componentService.setGeoObject({
          geocodeResult,
          exactPoint: { latitude: coords[0], longitude: coords[1] },
        });
      }),
    );
  };

  createBalloon(mapInstance: ymaps.Map): void {
    this.balloon = new ymaps.Balloon(mapInstance, {
      panelMaxMapArea: 400,
      maxWidth: 200,
    });

    this.balloon.options.setParent(mapInstance.options);
  }

  openBalloon(coords: ymaps.Coordinate, address: string): void {
    this.balloon.close();
    this.balloon.open(coords, address);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
